import React, { useEffect, useRef } from "react";

const BranchIcon = () => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="6" cy="4.5" r="1.8" />
    <circle cx="6" cy="15.5" r="1.8" />
    <circle cx="14" cy="8" r="1.8" />
    <path d="M6 6.3v7.4M14 9.8c0 3-8 1.5-8 4" />
  </svg>
);

const ChevronIcon = () => (
  <svg
    className="pl-chip-chevron"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 7.5l5 5 5-5" />
  </svg>
);

export function BranchChip({ label, title, onClick, expanded }) {
  if (!onClick) {
    return (
      <span className="pl-chip" title={title}>
        <BranchIcon />
        {label}
      </span>
    );
  }
  return (
    <button
      type="button"
      className="pl-chip pl-chip-button"
      aria-expanded={expanded}
      onClick={onClick}
    >
      <BranchIcon />
      {label}
      <ChevronIcon />
    </button>
  );
}

export function BranchesFold({ open, children }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.inert = !open;
    }
  }, [open]);

  return (
    <div className={`pl-fold${open ? " is-open" : ""}`}>
      <div className="pl-fold-clip" ref={ref}>
        <div className="pl-branches">{children}</div>
      </div>
    </div>
  );
}
